module.exports = __webpack_public_path__ + "static/media/forearmExtensorLeft.617502fa.png";